import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { OtterIntegrationName } from '../types';

import { getOtterIntegrationStatus, OTTER_QUERY_KEY } from '../domains/api';

type GetOtterIntegrationStatus = typeof getOtterIntegrationStatus;
type ApiResponseType = Awaited<ReturnType<GetOtterIntegrationStatus>>;

export function useOtterIntegration(
  siteId: number | undefined,
  integrationName: OtterIntegrationName,
  forceDisabled = false,
): UseQueryResult<ApiResponseType, AxiosError> {
  return useQuery<ApiResponseType, AxiosError>(
    [OTTER_QUERY_KEY, siteId, integrationName],
    () => getOtterIntegrationStatus(String(siteId), integrationName),
    {
      enabled: !forceDisabled && !!siteId,
      staleTime: 5 * 60 * 1000, // 5 minutes.
    },
  );
}
